import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { FaRegEdit, FaSearch, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Services } from "Services";
import { warningSwal } from "Util/Toast";
import SkeletonLoad from "Components/TableLoad/load";
import CommonClasses from "Styles/Common.module.css";
import { Helmet } from "react-helmet";
import Layout from "Components/Layout";
import UserClasses from './Users.module.css';
import { TablePagination } from "@mui/material";

function Users() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchString, setSearchString] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [imageErrors, setImageErrors] = useState({});
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const fetchUsers = () => {
        setLoading(true);
        Services.getUsers("POST", null, token)
            .then((response) => {
                setLoading(false);
                if (response.Status === 1) {
                    setData(response.Users);
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("Something went wrong. Please try again.");
                console.error(err);
            });
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleSearch = (event) => {
        setSearchString(event.target.value);
    };

    const filteredData = data.filter(user => {
        const lowerSearchString = searchString.toLowerCase();
        return (
            user.UserName.toLowerCase().includes(lowerSearchString) ||
            user.MobileNumber.toLowerCase().includes(lowerSearchString)
        );
    });

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const currentData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleImageError = (userId) => {
        setImageErrors(prev => ({
            ...prev,
            [userId]: true
        }));
    };

    return (
        <Layout Active={"Users"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Users</title>
            </Helmet>
            <div className={CommonClasses["Container"]}>
                <div>
                    <h1 style={{ color: '#FF0D0D' }}>USERS</h1>
                </div>
                <div className={CommonClasses["control-btns"]}>
                    <div className={UserClasses["search-container"]}>
                        <FaSearch className={UserClasses["search-icon"]} />
                        <input
                            type="text"
                            placeholder="Search Users By Name | Phone"
                            value={searchString}
                            onChange={handleSearch}
                            className={UserClasses["search-btn"]}
                        />
                    </div>
                </div>
                <div className={CommonClasses["wrapper"]}>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={["ProfilePicture", "UserName", "MobileNumber", "CreatedAt", "Status", "Actions"]}
                        />
                    ) : data.length > 0 ? (
                        <div className={CommonClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>ProfilePicture</th>
                                        <th>UserName</th>
                                        <th>MobileNumber</th>
                                        <th>CreatedAt</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item) => (
                                        <tr
                                            key={item.UserID}
                                            id={item.UserID}
                                            name={item.UserName}
                                            onClick={() => navigate(`/userdetails/${item.UserID}`, { state: { user: item } })}>
                                            <td style={{ padding: '8px', textAlign: 'center', verticalAlign: 'middle' }}>
                                                {(!item.ProfilePicture || imageErrors[item.UserID]) ? (
                                                    <div
                                                        style={{
                                                            width: "6rem",
                                                            height: "5rem",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            backgroundColor: "#f0f0f0",
                                                            borderRadius: "5px",
                                                            border: "2px solid #ddd",
                                                            margin: "0 auto"
                                                        }}
                                                    >
                                                        <FaUser size={40} color="#999" />
                                                    </div>
                                                ) : (
                                                    <img
                                                        style={{ 
                                                            width: "6rem", 
                                                            height: "5rem", 
                                                            objectFit: "cover", 
                                                            borderRadius: '5px',
                                                            display: "block",
                                                            margin: "0 auto"
                                                        }}
                                                        src={item.ProfilePicture}
                                                        alt="user-img"
                                                        onError={() => handleImageError(item.UserID)}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.open(item.ProfilePicture, "_blank");
                                                        }}
                                                    />
                                                )}
                                            </td>
                                            <td>{item.UserName}</td>
                                            <td>{item.CountryCode}{item.MobileNumber}</td>
                                            <td>
                                                <Moment format="DD-MM-YYYY">
                                                    {item.CreatedAt}
                                                </Moment>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <TablePagination
                                component="div"
                                count={filteredData.length}
                                page={page}
                                onPageChange={handlePageChange}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[5, 10, 25]}
                                className={UserClasses["pagination"]}
                                classes={{
                                    root: UserClasses["pagination-root"],
                                    toolbar: UserClasses["pagination-toolbar"],
                                    spacer: UserClasses["pagination-spacer"],
                                    selectLabel: UserClasses["pagination-selectLabel"],
                                    selectRoot: UserClasses["pagination-selectRoot"],
                                    select: UserClasses["pagination-select"],
                                    actions: UserClasses["pagination-actions"],
                                }}
                            />
                        </div>
                    ) : (
                        <div>
                            <p>No Users Found</p>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Users;
